import { FiChevronLeft } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'

const BackButton = ({ backTo }) => {
  const navigate = useNavigate()
  const goback = () => {
    if (backTo?.length > 0) {
      navigate(backTo)
    } else {
      navigate(-1)
    }
  }
  return (
    <div className="admin-back-button" onClick={goback}>
      <FiChevronLeft />
    </div>
  )
}

export default BackButton
